export default [
  {
    path: 'e/p/order/details',
    name: 'purchase-order-details',
    component: () => import('@/views/erp/purchase/order/components/details.vue')
  },
  {
    path: 'e/p/order/add',
    name: 'purchase-order-add',
    component: () => import('@/views/erp/purchase/order/components/create.vue')
  },
  {
    path: 'e/p/refund/details',
    name: 'purchase-refund-details',
    component: () => import('@/views/erp/purchase/refund/components/details.vue')
  },
  {
    path: 'e/p/refund/add',
    name: 'purchase-refund-add',
    component: () => import('@/views/erp/purchase/refund/components/create.vue')
  }
]
